import {
    GET_LEADS_DIVISIONS,
    GET_LEADS_DIVISIONS_SUCCESS,
    GET_LEADS_DIVISIONS_FAILURE,
} from '../constants/get_leads_divisions.constants';

export const getLeadsDivisionsRequest = () => ({
    type: GET_LEADS_DIVISIONS,
});

export const getLeadsDivisionsSuccess = leadsDivisions => ({
    type: GET_LEADS_DIVISIONS_SUCCESS,
    leadsDivisions,
});

export const getLeadsDivisionsFailure = error => ({
    type: GET_LEADS_DIVISIONS_FAILURE,
    error,
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Manage_retail/redux/actions/get_leads_divisions.actions.js